import { NodesById } from '../../../types'
import { Dimension } from '../../../../../../../../../features/dimension/types/Dimension'
import { findNodeCompanyId } from './companyUtils'

export const findDimensionName = (
  dimensionValue: string,
  nodeId: string,
  nodesById: NodesById,
  dimensionTrees: { [companyId: string]: Dimension[] | undefined }
): string | null => {
  // Find which company this dimension belongs to
  const nodeCompanyId = findNodeCompanyId(nodeId, nodesById)

  // Get the dimension tree for this specific company
  const relevantDimensionTree = nodeCompanyId ? dimensionTrees[nodeCompanyId] : undefined

  if (relevantDimensionTree) {
    const searchTree = (nodes: Dimension[]): string | null => {
      for (const treeNode of nodes) {
        if (String(treeNode.dimensionId) === dimensionValue || String(treeNode.id) === dimensionValue) {
          return treeNode.name
        }

        if (treeNode.children) {
          const found = searchTree(treeNode.children)
          if (found) return found
        }
      }
      return null
    }

    return searchTree(relevantDimensionTree)
  }

  // Fallback if no dimension tree found
  return null
}
